"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.reducer = exports.logout = exports.setThirdPartyAccount = exports.setMaestroAccount = exports.setAccountMessageData = exports.setLoginCompleteMessage = void 0;

var _redux = require("redux");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  accountSet: false,
  loginComplete: false,
  logoutComplete: false,
  maestroAccount: null,
  maestroLoggedIn: false,
  thirdPartyAccount: null
};
var MAESTRO_MESSAGE_LOGIN_COMPLETE = 'messageFromMaestro/LOGIN_COMPLETE';
var MAESTRO_MESSAGE_ACCOUNT_SET = 'meessageFromMaestro/ACCOUNT_SET';
var SET_MAESTRO_ACCOUNT = 'internalState/SET_MAESTRO_ACCOUNT';
var SET_THIRD_PARTY_ACCOUNT = 'internalState/SET_THIRD_PARTY_ACCOUNT';
var LOGOUT = 'internalState/LOGOUT';

var setLoginCompleteMessage = function setLoginCompleteMessage(payload) {
  return {
    payload: payload,
    type: MAESTRO_MESSAGE_LOGIN_COMPLETE
  };
};

exports.setLoginCompleteMessage = setLoginCompleteMessage;

var setAccountMessageData = function setAccountMessageData(payload) {
  return {
    payload: payload,
    type: MAESTRO_MESSAGE_ACCOUNT_SET
  };
};

exports.setAccountMessageData = setAccountMessageData;

var setMaestroAccount = function setMaestroAccount(_ref) {
  var account = _ref.account,
      loggedIn = _ref.loggedIn;
  return {
    payload: {
      account: account,
      loggedIn: loggedIn
    },
    type: SET_MAESTRO_ACCOUNT
  };
};

exports.setMaestroAccount = setMaestroAccount;

var setThirdPartyAccount = function setThirdPartyAccount(payload) {
  return {
    payload: payload,
    type: SET_THIRD_PARTY_ACCOUNT
  };
};

exports.setThirdPartyAccount = setThirdPartyAccount;

var logout = function logout() {
  return {
    type: LOGOUT
  };
};

exports.logout = logout;

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case SET_MAESTRO_ACCOUNT:
      {
        var account = payload.account,
            loggedIn = payload.loggedIn;
        return _objectSpread({}, state, {
          maestroAccount: account,
          maestroLoggedIn: loggedIn
        });
      }

    case SET_THIRD_PARTY_ACCOUNT:
      {
        return _objectSpread({}, state, {
          thirdPartyAccount: payload
        });
      }

    case MAESTRO_MESSAGE_ACCOUNT_SET:
      {
        var maestroAccount = payload.maestroAccount,
            thirdPartyAccount = payload.thirdPartyAccount,
            accountSet = payload.accountSet;
        return _objectSpread({}, state, {
          accountSet: accountSet,
          loginComplete: maestroAccount ? true : false,
          maestroAccount: maestroAccount,
          maestroLoggedIn: maestroAccount ? true : false,
          thirdPartyAccount: thirdPartyAccount
        });
      }

    case MAESTRO_MESSAGE_LOGIN_COMPLETE:
      {
        return _objectSpread({}, state, {
          loginComplete: payload,
          maestroLoggedIn: payload
        });
      }

    case LOGOUT:
      {
        return _objectSpread({}, state, {
          accountSet: false,
          loginComplete: false,
          logoutComplete: true,
          maestroAccount: null,
          maestroLoggedIn: false,
          thirdPartyAccount: null
        });
      }

    default:
      {
        return _objectSpread({}, state);
      }
  }
};

exports.reducer = reducer;
var store = _redux.createStore;
exports.store = store;